module.exports = __webpack_public_path__ + "static/media/Slide66.1885560a.JPG";